// if (!customElements.get("product-form")) {
//   customElements.define(
//     "product-form",
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector("form");
//         this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
//         this.cartNotification = document.querySelector("cart-notification");
//         this.cartItems = document.querySelector("cart-items");
//         this.quickViewWarpper = document.getElementById("quickViewWrapper");
//         //console.log(this.cartNotification);
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();

//         const submitButton = this.querySelector('[type="submit"]');

//         submitButton.setAttribute("disabled", true);
//         submitButton.classList.add("loading");
//         // Get Cart API
//         let config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         let formData = new FormData(this.form);
//         if (this.cartNotification) {
//           formData.append(
//             "sections",
//             this.cartNotification
//               .getSectionsToRender()
//               .map((section) => section.id)
//           );
//           this.cartNotification.setActiveElement(document.activeElement);
//         }

//         if (this.cartItems) {
//           formData.append(
//             "sections",
//             this.cartItems
//               .getSectionsToRender()
//               .map((section) => section.section)
//           );
//         }

//         formData.append("sections_url", window.location.pathname);
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((parsedState) => {
//             if (parsedState.status) {
//               this.handleErrorMessage(parsedState.description);
//               return;
//             }
//             if (this.cartNotification) {
//               this.cartNotification.renderContents(parsedState);
//             }

//             if (this.cartItems) {
//               this.cartItems.renderContents(parsedState);
//             }

//             document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             submitButton.classList.remove("loading");
//             submitButton.removeAttribute("disabled");
//             this.quickViewWarpper?.classList.remove("show__modal");
//             document.body.classList.remove("overflow-hidden");
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message"
//           );
//         this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//           this.errorMessageWrapper.classList.remove("no-js-inline");
//         }
//       }
//     }
//   );
// }

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (!this.form) {
          console.warn("Product form not found.");
          return;
        }

        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.cartNotification =
          document.querySelector("cart-notification");

        this.cartItems =
          document.querySelector("cart-items");

        this.quickViewWarpper =
          document.getElementById("quickViewWrapper");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton =
          this.querySelector('[type="submit"]');

        if (!submitButton) return;

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");

        /*
        ==========================================
        SHOPIFY PRODUCT FORM
        ==========================================
        */

        const formData = new FormData(this.form);

        /*
        ==========================================
        FILE UPLOAD SUPPORT
        ==========================================
        */

        /*
        Find all file inputs which belong
        to this product form.
        */

        const fileInputs = document.querySelectorAll(
          'input[type="file"][form="' + this.form.id + '"]'
        );

        fileInputs.forEach((fileInput) => {
          if (
            fileInput.files &&
            fileInput.files.length > 0
          ) {
            const file = fileInput.files[0];

            /*
            Remove any existing value
            for the same property.
            */

            formData.delete(fileInput.name);

            /*
            Add the REAL File object.
            */

            formData.append(
              fileInput.name,
              file,
              file.name
            );
          }
        });

        /*
        ==========================================
        CART NOTIFICATION SECTIONS
        ==========================================
        */

        if (this.cartNotification) {
          const sections =
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id);

          if (sections.length) {
            formData.append(
              "sections",
              sections.join(",")
            );
          }

          this.cartNotification.setActiveElement(
            document.activeElement
          );
        }

        /*
        ==========================================
        CART ITEMS SECTIONS
        ==========================================
        */

        if (this.cartItems) {
          const sections =
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section);

          if (sections.length) {
            formData.append(
              "sections",
              sections.join(",")
            );
          }
        }

        /*
        ==========================================
        SECTION URL
        ==========================================
        */

        formData.append(
          "sections_url",
          window.location.pathname
        );

        /*
        ==========================================
        FETCH CONFIG
        ==========================================
        */

        const config = {
          method: "POST",

          headers: {
            "X-Requested-With":
              "XMLHttpRequest",

            Accept:
              "application/json"
          },

          /*
          IMPORTANT:

          DO NOT set Content-Type manually.

          Browser will automatically set:

          multipart/form-data;
          boundary=----------------

          This is required for file uploads.
          */

          body: formData
        };

        /*
        ==========================================
        ADD PRODUCT TO CART
        ==========================================
        */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => {

            if (!response.ok) {
              return response
                .json()
                .then((error) => {
                  throw error;
                });
            }

            return response.json();
          })

          .then((parsedState) => {

            /*
            ======================================
            SHOPIFY ERROR
            ======================================
            */

            if (parsedState.status) {
              this.handleErrorMessage(
                parsedState.description ||
                  parsedState.message ||
                  "Unable to add product to cart."
              );

              return;
            }

            /*
            ======================================
            CART NOTIFICATION
            ======================================
            */

            if (this.cartNotification) {
              this.cartNotification.renderContents(
                parsedState
              );
            }

            /*
            ======================================
            CART ITEMS
            ======================================
            */

            if (this.cartItems) {
              this.cartItems.renderContents(
                parsedState
              );
            }

            /*
            ======================================
            REMOVE ERROR
            ======================================
            */

            document
              .querySelector(
                ".product-form__error-message-wrapper"
              )
              ?.classList.add(
                "no-js-inline"
              );
          })

          .catch((error) => {

            console.error(
              "Product form error:",
              error
            );

            this.handleErrorMessage(
              error?.description ||
                error?.message ||
                "Something went wrong. Please try again."
            );
          })

          .finally(() => {

            /*
            ======================================
            RESET BUTTON
            ======================================
            */

            submitButton.classList.remove(
              "loading"
            );

            submitButton.removeAttribute(
              "disabled"
            );

            /*
            ======================================
            QUICK VIEW
            ======================================
            */

            this.quickViewWarpper?.classList.remove(
              "show__modal"
            );

            document.body.classList.remove(
              "overflow-hidden"
            );
          });
      }

      /*
      ==========================================
      ERROR MESSAGE
      ==========================================
      */

      handleErrorMessage(
        errorMessage = false
      ) {

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        /*
        If error wrapper does not exist,
        stop safely.
        */

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {

          this.errorMessage.textContent =
            errorMessage;

          this.errorMessageWrapper.classList.remove(
            "no-js-inline"
          );
        }
      }
    }
  );
}
